import { createTRPCClient, httpBatchLink } from '@trpc/client';
import superjson from 'superjson';
import { supabase } from '@/client/lib/supabase';
import type { AppRouter } from '../../server/routers/_app';
import { trpc } from './trpc';

function makeLink() {
  return httpBatchLink({
    transformer: superjson,
    url: '/trpc',
    async headers() {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      return session?.access_token ? { authorization: `Bearer ${session.access_token}` } : {};
    },
  });
}

export const trpcClient = trpc.createClient({ links: [makeLink()] });

export const trpcVanilla = createTRPCClient<AppRouter>({ links: [makeLink()] });
